<template>
  <div>
    <priority-dialog
      v-model="isPriorityDialogOpened"
      :priority="selectedPriority"
      :maker="maker"
      @save="stateSave"
      @close="resetSelectedPriority"/>
    <delete-priority-dialog
      v-model="isDeletePriorityDialogOpened"
      :priority="selectedPriority"
      @delete="stateDelete"
      @close="resetSelectedPriority"/>
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Priorités</span>
      <v-spacer></v-spacer>
      <v-btn dark color="primary" elevation="0" @click="isPriorityDialogOpened = true" v-if="admin">
        <v-icon left>add</v-icon>
        Nouvelle priorité
      </v-btn>
    </v-row>
    <slot name="beforeList" />
    <n-card v-if="isFetching">
      <v-row no-gutters justify="center" align="center" class="my-8">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
          style="max-width: 200px;"
        ></v-progress-linear>
      </v-row>
    </n-card>
    <n-card v-else-if="!makerPriorities.length">
      <v-row no-gutters justify="center" align="center" class="pa-4 text--secondary" style="min-height: 100px;">
        Aucune priorité
      </v-row>
    </n-card>
    <div class="page-main-content" v-else>
      <v-simple-table class="pt-5">
        <thead>
          <tr>
            <th class="text-left">Nom</th>
            <th/>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(priority, i) in makerPriorities" :key="`${i}-${priority.name}`">
            <td>{{ priority.name }}</td>
            <td class="text-right admin-list-actions">
              <v-btn icon small @click="savePriority(priority)" v-if="admin">
                <v-icon>edit</v-icon>
              </v-btn>
              <!-- <v-btn icon small>
                <v-icon color="red" @click="deletePriority(priority)">delete</v-icon>
              </v-btn> -->
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PriorityDialog from '@/components/Priority/PriorityDialog.vue';
import DeletePriorityDialog from '@/components/Priority/DeletePriorityDialog.vue';

export default {
  name: `SettingsPriorities`,
  props: {
    maker: Object,
    admin: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data: () => ({
    isFetching: true,
    isPriorityDialogOpened: false,
    isDeletePriorityDialogOpened: false,
    selectedPriority: {},
  }),
  computed: {
    ...mapState(`model/priority`, [
      `makerPriorities`,
    ]),
  },
  methods: {
    savePriority(priority) {
      this.selectedPriority = priority;
      this.isPriorityDialogOpened = true;
    },
    deletePriority(priority) {
      this.selectedPriority = priority;
      this.isDeletePriorityDialogOpened = true;
    },
    async fetchPriorities() {
      // await this.$store.dispatch(`model/client/fetchCompany`);
      this.isFetching = true;
      this.$store.commit(`model/priority/SET_MAKER_PRIORITIES`, []);
      await this.$store.dispatch(`model/priority/fetchMakerPriorities`, this.maker.id);
      this.isFetching = false;
    },
    async stateSave() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: this.selectedPriority && this.selectedPriority.id ? `Priorité modifiée avec succès` : `Priorité créée avec succès`,
      });
      this.selectedPriority = {};
    },
    async stateDelete() {
      await this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Priorité supprimée avec succès`,
      });
      this.selectedStatus = {};
    },
    resetSelectedPriority() {
      this.selectedPriority = {};
    },
  },
  mounted() {
    this.fetchPriorities();
  },
  components: {
    PriorityDialog,
    DeletePriorityDialog,
  },
};
</script>
